import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { AppFooter } from '../components/AppFooter';
import { ImpersonationBanner } from '../components/ImpersonationBanner';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <ImpersonationBanner />
      <Outlet />
      <AppFooter />
    </>
  ),
});
